import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { UserSliceInitialState } from '@/domains/user/store/types/UserSliceInitialState';
import type { User } from '@/domains/user/types/User';
import { SaveUserCustomInboxRequest } from '@/domains/user/types/api/requests/SaveUserCustomInboxRequest';
import type { CustomInbox, CustomInboxesRecord } from '@/features/customInbox/types/CustomInbox';

const initialState: UserSliceInitialState = {
  user: null,
  inboxes: {},
};

const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    getUserData: (_, _payload: PayloadAction<{ resetCache?: boolean } | undefined>) => {},
    getUserDataSuccess: (state, { payload }: PayloadAction<User>) => {
      state.user = payload;
    },
    resetUserData: (state) => {
      state.user = initialState.user;
    },
    getUserCustomInboxes: (_state, _action: PayloadAction<{ location: string; resetCache?: boolean }>) => {},
    getUserCustomInboxesSuccess: (state, { payload }: PayloadAction<CustomInboxesRecord>) => {
      state.inboxes = payload;
    },
    updateCustomInboxCounter: (
      state,
      { payload: { id, location, counter } }: PayloadAction<{ location: string; id: number; counter: number }>,
    ) => {
      if (state.inboxes[location]) {
        const inboxes: CustomInbox[] = state.inboxes?.[location] || [];
        const customInbox = inboxes.find((inbox) => inbox.id === id);
        if (customInbox) customInbox.counter = counter;
      }
    },
    saveUserCustomInboxes: (_state, _action: PayloadAction<SaveUserCustomInboxRequest>) => {},
    deleteUserCustomInbox: (_state, _action: PayloadAction<number>) => {},
  },
});

export const {
  getUserData,
  getUserDataSuccess,
  resetUserData,
  saveUserCustomInboxes,
  getUserCustomInboxes,
  getUserCustomInboxesSuccess,
  deleteUserCustomInbox,
  updateCustomInboxCounter,
} = userSlice.actions;

export const userSliceReducerPath = userSlice.reducerPath;

export const userSliceReducer = userSlice.reducer;
